import { useState } from 'react';
import { TagsState } from '../../model/map/map';
import { WP_Filter_Children, WP_Parent_Tag } from '../../model/tags/tags';
import { FilterSubMenuAllItems } from './FilterSubMenuAllItems';
import { FilterSubMenuItem } from './FilterSubMenuItem';
import { FormattedMessage, useIntl } from 'react-intl';

interface FilterSubMenuProps {
  multipleSelect: boolean;
  currentCategoryDataSelected: WP_Parent_Tag;
  childrenTags: WP_Filter_Children[] | null;
  selectedParentTagId: number | null;
  isSubTagSelected: (children, parentId) => boolean;
  selectSubTag: (children, parentId, checked) => void;
  setAllSelected: (selectedParentTagId, checked) => void;
  selectedSubTags: TagsState[] | null;
}

export const FilterSubMenu: React.FC<FilterSubMenuProps> = ({
  multipleSelect,
  currentCategoryDataSelected,
  childrenTags,
  selectedParentTagId,
  isSubTagSelected,
  selectSubTag,
  setAllSelected,
  selectedSubTags,
}) => {
  const [query, setQuery] = useState('');

  const intl = useIntl();

  const selectParentsTags = selectedSubTags?.filter(
    (subtags) => subtags.parentTagId === selectedParentTagId
  );
  const selectParentsTagsLength = selectParentsTags
    ? selectParentsTags[0].tags.length
    : null;

  const checked =
    childrenTags?.length === selectParentsTagsLength ? true : false;

  return (
    <div className="flex flex-col justify-between h-full">
      <div className="h-full">
        <div className="relative flex flex-col h-full overflow-hidden">
          <h2 className="flex items-center flex-col text-xl text-center text-black font-bold mb-8  px-8">
            <div
              className="flex justify-center items-center rounded-full min-w-[2.5rem] h-16 w-16 mb-5"
              style={{
                backgroundColor:
                  currentCategoryDataSelected.acf.category_place_color,
              }}
            >
              <i
                className={
                  `text-white fa-lg ` +
                  currentCategoryDataSelected.acf.category_place_icon?.class
                }
              ></i>
            </div>
            {currentCategoryDataSelected.name}
          </h2>
          {childrenTags !== null && childrenTags.length > 10 && (
            <div className="justify-start items-start text-left w-full px-4 pb-4">
              <input
                type="text"
                value={query}
                onChange={(event) => {
                  setQuery(event.target.value);
                }}
                placeholder={intl.formatMessage({
                  id: `${currentCategoryDataSelected.slug} Placeholder`,
                })}
                className="w-full rounded-full border-2 border-gray-500 focus:border-gray-500 ring-0 focus:ring-0 active:ring-0 ring-offset-0 active:ring-offset-0 outline-none active:outline-none bg-white text-gray-400 not-italic px-4"
              ></input>
            </div>
          )}
          <ul className="h-full overflow-scroll scrollbar-hide px-8 md:thin-scrollbar">
            {childrenTags !== null ? (
              childrenTags.length > 0 ? (
                <>
                  {multipleSelect && (
                    <FilterSubMenuAllItems
                      setAllSelected={setAllSelected}
                      selectedParentTagId={selectedParentTagId}
                      checked={checked}
                    />
                  )}
                  {childrenTags
                    .filter(
                      (tag) =>
                        !query ||
                        tag.name
                          .toLowerCase()
                          .normalize('NFD')
                          .replace(/\p{Diacritic}/gu, '')
                          .indexOf(
                            query
                              .toLowerCase()
                              .normalize('NFD')
                              .replace(/\p{Diacritic}/gu, '')
                          ) >= 0
                    )
                    .map((child, index) => {
                      return (
                        <FilterSubMenuItem
                          child={child}
                          key={index}
                          index={index}
                          selectedParentTagId={selectedParentTagId}
                          isSubTagSelected={isSubTagSelected}
                          selectSubTag={selectSubTag}
                        />
                      );
                    })}
                </>
              ) : (
                <div className="w-full text-center px-4">
                  <p>
                    <FormattedMessage id="Loading" />
                  </p>
                </div>
              )
            ) : (
              <div className="w-full text-center px-4">
                <p>
                  <FormattedMessage id="No places available" />
                </p>
              </div>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};
